import { FC } from 'react';
import { InnerIconProps, withIcon } from '@tempusfinance/common-ui';

const LockComponent: FC<InnerIconProps> = ({ size, color }) => {
  const colorVar = `var(--icon-color, var(${color}))`;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="nostra__icon nostra__icon__lock"
      width={size}
      height={size}
      viewBox="0 0 10 10"
      fill="none"
    >
      <g clipPath="url(#clip0_1861_1100)">
        <path
          d="M7.91667 4.58337H2.08333C1.6231 4.58337 1.25 4.95647 1.25 5.41671V8.33337C1.25 8.79361 1.6231 9.16671 2.08333 9.16671H7.91667C8.3769 9.16671 8.75 8.79361 8.75 8.33337V5.41671C8.75 4.95647 8.3769 4.58337 7.91667 4.58337Z"
          stroke={colorVar}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M2.91667 4.58337V2.91671C2.91667 2.36417 3.13617 1.83427 3.52687 1.44357C3.91757 1.05287 4.44747 0.833374 5.00001 0.833374C5.55254 0.833374 6.08244 1.05287 6.47314 1.44357C6.86384 1.83427 7.08334 2.36417 7.08334 2.91671V4.58337"
          stroke={colorVar}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_1861_1100">
          <rect width="10" height="10" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const Lock = withIcon(LockComponent);
